import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { TranslateLoaderService } from './core/services/internationalization/translate-loader.service';
import { environment } from '../environments/environment';
import { AnalyticsService } from './core/services/adobe-analytics/analytics.service';
import { CookiebotCallbackService } from './core/services/cookiebot/cookiebotCallbackService.service';
import { MonitoringService } from './core/services/monitoring/monitoring.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'quoteandbuy.client';

  private readonly iconPaths: [string, string][] = [
    ['phone-call', 'phone-call.svg'],
    ['bike', 'bike.svg'],
    ['user', 'user.svg'],
    ['list', 'list.svg'],
    ['menu', 'menu.svg'],
    ['clear', 'x.svg'],
    ['electronico','electronico.svg'],
    ['arrow-down-right', 'arrow-down-right.svg'],
    ['edit', 'edit.svg'],
    ['trash-2', 'trash-2.svg'],
    ['file-text', 'file-text.svg'],
    ['dollar-sign', 'dollar-sign.svg'],
    ['mail', 'mail.svg'],
    ['info', 'info.svg'],
    ['sunset', 'sunset.svg'],
    ['check-circle', 'check-circle.svg'],
    ['download', 'download.svg'],
    ['lock', 'lock.svg'],
    ['clock', 'clock.svg'],
    ['globe', 'globe.svg'],
    ['star', 'star.svg'],
    ['aperture', 'aperture.svg'],
    ['alert-octagon', 'alert-octagon.svg'],
    ['file', 'file.svg'],
    ['bike_amarillo', 'bike_amarillo.svg'],
    ['image', 'image.svg'],
    ['nieve', 'nieve.svg'],
    ['snow', 'nieve.svg'],
    ['refund', 'refund.svg'],
    ['pdf', 'pdf.svg'],
    ['golf', 'golf.svg'],
    ['sad-face', 'sad-face.svg'],
    ['euro-white', 'euro-white.svg'],
    ['creditCard', 'creditCard.svg'],
    ['noAsistencia', 'noAsistencia.svg'],
    ['alertPinkIcon', 'alertPinkIcon.svg'],
    ['alertYellowIcon', 'alertYellowIcon.svg'],
    ['alertBlueIcon', 'alertBlueIcon.svg'],
    ['pink-trash', 'pink-trash.svg'],
    ['arrow-up-right-yellow', 'arrow-up-right-yellow.svg'],
    ['home-icon', 'home-icon.svg'],
    ['downloadPink', 'downloadPink.svg'],
    ['camera-off', 'camera-off.svg'],
    ['cell-phone', 'cell-phone.svg'],
    ['masterdCard-icon', 'mastercard.svg'],
    ['calendar', 'calendar.svg'],
    ['shield', 'shield.svg'],
    ['vector', 'vector.svg'],
    ['home', 'home.svg'],
    ['heart', 'heart.svg'],
    ['briefcase', 'briefcase.svg'],
    ['file-text', 'file-text.svg'],
    ['user-x', 'user-x.svg'],
    ['credit-card', 'credit-card.svg'],
    ['activity', 'activity.svg'],
    ['burglar', 'burglar.svg'],
    ['plane', 'plane.svg'],
    ['bookmark', 'bookmark.svg'],
    ['repeat', 'repeat.svg'],
    ['frown', 'frown.svg'],

  ];

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    public translate: TranslateService,
    private translateLoaderService: TranslateLoaderService,
    private titleService: Title,
    private metaService: Meta,
    private analyticsService: AnalyticsService,
    private cookiebotCallbackService: CookiebotCallbackService,
    private monitoringService: MonitoringService,
  ) {
    this.monitoringService.loadScript();
    this.loadCookiebotService();
    this.setupIcons();
    this.setupTitleAndMeta();
    this.translateLoaderService.init();
    this.analyticsService.initAdobeLaunchDataLayer();  
  }

  ngOnInit() {}
  
    private setupIcons() {
    this.iconPaths.forEach(([iconName, iconPath]) => {
      this.matIconRegistry.addSvgIcon(
        iconName,
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          `assets/icons/${iconPath}`
        )
      );
    });
  }

  loadCookiebotService() {
    const onCookiebotLoad = () => {
      this.cookiebotCallbackService.onAccept();
    };

    const checkCookiebotLoaded = () => {
      if (window.Cookiebot && window.Cookiebot.consent) {
        onCookiebotLoad();
      } else {
        setTimeout(checkCookiebotLoaded, 100);
      }
    };

    checkCookiebotLoaded();

    window.addEventListener('CookiebotOnLoad', onCookiebotLoad);
  }

  private setupTitleAndMeta() {
    this.titleService.setTitle(environment.app_name);
    this.metaService.addTags([
      { name: 'apple-mobile-web-app-title', content: environment.app_name },
    ]);
  }
}
